/**
 * 將傳入的文字與關鍵字以 <mark>keyword</mark> 的結構回傳
 * @param planText: string, keyword: string
 * @returns string
 */

import sanitizeHtml from 'sanitize-html';

const provideMarkerText = (planText: string, keyword: string): string => {
  if (keyword) {
    const pattern: RegExp = new RegExp(
      keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'),
      'gi'
    );
    const result = planText.replace(pattern, '<mark>$&</mark>');
    return sanitizeHtml(result, { allowedTags: ['mark'] });
  }
  return planText;
};

export default provideMarkerText;
